import { useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { CREATE_ENTITY, UPDATE_ENTITY, DELETE_ENTITY } from '../lib/graphql/mutations';

const client = generateClient();

export function useEntityMutation() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function createEntity(entityName: string, attributes: Record<string, any>): Promise<string | undefined> {
    setIsSubmitting(true);
    setError(null);
    try {
      const result = await client.graphql({
        query: CREATE_ENTITY,
        variables: { entityName, attributes: JSON.stringify(attributes) },
      });
      const response = (result as any).data.createEntity;
      const parsed = typeof response === 'string' ? JSON.parse(response) : response;
      if (!parsed || typeof parsed.id !== 'string' || parsed.id === '') {
        console.warn('Unexpected createEntity response shape:', parsed);
      }
      return parsed?.id;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  async function updateEntity(entityName: string, attributes: Record<string, any>): Promise<void> {
    setIsSubmitting(true);
    setError(null);
    try {
      await client.graphql({
        query: UPDATE_ENTITY,
        variables: { entityName, attributes: JSON.stringify(attributes) },
      });
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  async function deleteEntity(entityName: string, id: string): Promise<void> {
    setIsSubmitting(true);
    setError(null);
    try {
      await client.graphql({
        query: DELETE_ENTITY,
        variables: { entityName, id },
      });
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  return { createEntity, updateEntity, deleteEntity, isSubmitting, error };
}
